module.exports = __webpack_public_path__ + "46d91b0f7bd77dfbcf621f2e550f79bd.woff2";